import { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { DashboardTab } from './components/DashboardTab';
import { TreasuryTab } from './components/TreasuryTab';
import { BudgetTab } from './components/BudgetTab';
import { SecurityTab } from './components/SecurityTab';
import { AccountTab } from './components/AccountTab';
import { SupportTab } from './components/SupportTab';
import BankTab from './components/BankTab';
import { GrantsManagement } from './components/GrantsManagement';
import { ModulesMetiersTab } from './components/ModulesMetiersTab';
import { RapportsTab } from './components/RapportsTab';
import { DafSpaceTab } from './components/DafSpaceTab';
import { PermissionGuard } from './components/PermissionGuard';
import { AuthPage } from './components/AuthPage';
import { ResetPasswordPage } from './components/ResetPasswordPage';
import { WelcomeTutorial } from './components/WelcomeTutorial';
import { UserLayout } from './components/layout/UserLayout';
import { AdminDashboardNew } from './pages/AdminDashboardNew';
import { LandingPage } from './pages/LandingPage';
import { FonctionnalitesPage } from './pages/FonctionnalitesPage';
import PrevisionTresoreriePage from './pages/features/PrevisionTresoreriePage';
import StressTestTresoreriePage from './pages/features/StressTestTresoreriePage';
import SuiviSubventionsPage from './pages/features/SuiviSubventionsPage';
import AlertesTresoreriePage from './pages/features/AlertesTresoreriePage';
import ReportingFinancierPage from './pages/features/ReportingFinancierPage';
import TableauBordTempsReelPage from './pages/features/TableauBordTempsReelPage';
import { ClientsPage } from './pages/ClientsPage';
import { TarifsPage } from './pages/TarifsPage';
import { AgriculturePage } from './pages/AgriculturePage';
import { GestionTresorerieAssociationPage } from './pages/GestionTresorerieAssociationPage';
import { GestionTresoreriePMEPage } from './pages/GestionTresoreriePMEPage';
import { SimulateurTresorerieAssociationPage } from './pages/SimulateurTresorerieAssociationPage';
import BetaFoundersPage from './pages/BetaFoundersPage';
import ForecastListPage from './pages/ForecastListPage';
import ForecastNewPage from './pages/ForecastNewPage';
import ForecastEditPage from './pages/ForecastEditPage';
import ForecastDashboardPage from './pages/ForecastDashboardPage';
import { StressTestPage } from './pages/StressTestPage';
import { BlogListPage } from './pages/BlogListPage';
import { BlogArticlePage } from './pages/BlogArticlePage';
import { ReferralPage } from './pages/ReferralPage';
import { PMEDashboardPage } from './pages/pme/PMEDashboardPage';
import { PMEInvoicesPage } from './pages/pme/PMEInvoicesPage';
import { PMEExpensesPage } from './pages/pme/PMEExpensesPage';
import { AgricultureModule } from './components/agri/AgricultureModule';
import { ReferralRedirectPage } from './pages/ReferralRedirectPage';
import { PolitiqueConfidentialitePage } from './pages/PolitiqueConfidentialitePage';
import { MentionsLegalesPage } from './pages/MentionsLegalesPage';
import { ConditionsGeneralesUtilisationPage } from './pages/ConditionsGeneralesUtilisationPage';
import GestionTresoreriePage from './pages/seo/GestionTresoreriePage';
import PlanTresoreriePage from './pages/seo/PlanTresoreriePage';
import PrevisionTresorerieSeoPage from './pages/seo/PrevisionTresorerieSeoPage';
import LogicielTresoreriePage from './pages/seo/LogicielTresoreriePage';
import LogicielTresorerieAssociationPage from './pages/seo/LogicielTresorerieAssociationPage';
import LogicielTresorerieEntreprisePage from './pages/seo/LogicielTresorerieEntreprisePage';
import GestionTresorerieTPEPage from './pages/seo/GestionTresorerieTPEPage';
import OutilPrevisionTresoreriePage from './pages/seo/OutilPrevisionTresoreriePage';
import LogicielPrevisionTresoreriePage from './pages/seo/LogicielPrevisionTresoreriePage';
import ExcelTresorerieAssociationPage from './pages/seo/longtail/ExcelTresorerieAssociationPage';
import ModelePlanTresoreriePage from './pages/seo/longtail/ModelePlanTresoreriePage';
import PlanTresoreriePMEPage from './pages/seo/longtail/PlanTresoreriePMEPage';
import SubventionRetardTresoreriePage from './pages/seo/longtail/SubventionRetardTresoreriePage';
import SuiviTresorerieEntrepriseExcelPage from './pages/seo/longtail/SuiviTresorerieEntrepriseExcelPage';
import TableauTresorerieGratuitPage from './pages/seo/longtail/TableauTresorerieGratuitPage';
import BFRTresoreriePage from './pages/seo/longtail/BFRTresoreriePage';
import ExcelVsLogicielTresoreriePage from './pages/seo/longtail/ExcelVsLogicielTresoreriePage';
import ManqueTresoreriePage from './pages/seo/longtail/ManqueTresoreriePage';
import CashFlowEntreprisePage from './pages/seo/longtail/CashFlowEntreprisePage';
import TresorerieSimplePage from './pages/seo/longtail/TresorerieSimplePage';
import TresorerieVsResultatPage from './pages/seo/longtail/TresorerieVsResultatPage';
import TresorerieAssociationLoi1901Page from './pages/seo/longtail/TresorerieAssociationLoi1901Page';
import AlerteTresoreriePage from './pages/seo/longtail/AlerteTresoreriePage';
import TresorerieSaisonniereRestaurantPage from './pages/seo/longtail/TresorerieSaisonniereRestaurantPage';
import TresorerieStartupPage from './pages/seo/longtail/TresorerieStartupPage';
import ProblemeCashFlowPage from './pages/seo/longtail/ProblemeCashFlowPage';
import ReportingFinancierAssociationPage from './pages/seo/longtail/ReportingFinancierAssociationPage';
import StressTestTresorerieSeoPage from './pages/seo/longtail/StressTestTresorerieSeoPage';
import TresorerieImmobilierPage from './pages/seo/longtail/TresorerieImmobilierPage';
import TresorerieFreelancePage from './pages/seo/longtail/TresorerieFreelancePage';
import TresorerieEssSocialPage from './pages/seo/longtail/TresorerieEssSocialPage';
import { SubscriptionRequired } from './components/SubscriptionRequired';
import { useAdminCheck } from './hooks/useAdminCheck';
import { useTrialStatus } from './hooks/useTrialStatus';
import { useAccountNotification } from './hooks/useAccountNotification';
import { useSupportNotifications } from './hooks/useSupportNotifications';
import { useSubscriptionAccess } from './hooks/useSubscriptionAccess';
import { usePackAccess } from './hooks/usePackAccess';
import { usePermissions } from './hooks/usePermissions';
import { useAuth } from './contexts/AuthContext';
import { initializeUserData } from './utils/initUserData';
import { supabase } from './lib/supabase';
import { ModuleSelectionModal } from './components/ModuleSelectionModal';
import { CookieConsentManager } from './components/cookies/CookieConsentManager';

function AuthenticatedApp() {
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState<{ first_name: string; tutorial_completed: boolean } | null>(null);
  const [showTutorial, setShowTutorial] = useState(false);
  const { user, impersonatedUserId, effectiveUserId } = useAuth();
  const { permissions, needsModuleSelection, refresh: refreshPermissions } = usePermissions();
  const [showModuleModal, setShowModuleModal] = useState(false);

  useEffect(() => {
    if (user && effectiveUserId) {
      initializeUserData();
      loadUserProfile();
    }
  }, [user, effectiveUserId]);

  useEffect(() => {
    if (needsModuleSelection && !showTutorial) {
      setShowModuleModal(true);
    }
  }, [needsModuleSelection, showTutorial]);

  async function loadUserProfile() {
    if (!effectiveUserId) return;

    const { data } = await supabase
      .from('user_profiles')
      .select('first_name, tutorial_completed')
      .eq('id', effectiveUserId)
      .maybeSingle();

    if (data) {
      setUserProfile(data);
      if (!data.tutorial_completed && !impersonatedUserId) {
        setShowTutorial(true);
      }
    }
  }

  function handleTutorialComplete() {
    setShowTutorial(false);
    loadUserProfile();
  }

  return (
    <>
      {showTutorial && <WelcomeTutorial onComplete={handleTutorialComplete} />}

      {showModuleModal && (
        <ModuleSelectionModal
          isOpen={showModuleModal}
          onClose={() => setShowModuleModal(false)}
          onModuleSelected={async () => {
            await refreshPermissions();
            setShowModuleModal(false);
          }}
          required={true}
        />
      )}

      <UserLayout>
        <Routes>
          <Route index element={
            <DashboardTab
              onAddTransaction={() => navigate('/app/treasury')}
              onCreateBudget={() => navigate('/app/budget')}
              onViewCashFlow={() => navigate('/app/stress-test')}
            />
          } />
          <Route path="treasury" element={<TreasuryTab />} />
          <Route path="bank" element={<BankTab />} />
          <Route path="budget" element={<BudgetTab />} />
          <Route
            path="grants"
            element={
              <PermissionGuard requires="associations">
                <GrantsManagement />
              </PermissionGuard>
            }
          />
          <Route path="security" element={<SecurityTab />} />
          <Route path="forecast" element={<ForecastListPage />} />
          <Route path="forecast/new" element={<ForecastNewPage />} />
          <Route path="forecast/:id" element={<ForecastDashboardPage />} />
          <Route path="forecast/:id/edit" element={<ForecastEditPage />} />
          <Route path="stress-test" element={<StressTestPage />} />
          <Route path="modules" element={<ModulesMetiersTab />} />
          <Route path="rapports" element={<RapportsTab />} />
          <Route path="daf" element={<DafSpaceTab />} />
          <Route path="settings" element={<AccountTab onBackToDashboard={() => navigate('/app')} />} />
          <Route path="support" element={<SupportTab onBackToDashboard={() => navigate('/app')} />} />
          <Route path="account" element={<AccountTab onBackToDashboard={() => navigate('/app')} />} />
          <Route path="referral" element={<ReferralPage />} />
          <Route path="pme" element={<PermissionGuard requires="pme"><PMEDashboardPage /></PermissionGuard>} />
          <Route path="pme/invoices" element={<PermissionGuard requires="pme"><PMEInvoicesPage /></PermissionGuard>} />
          <Route path="pme/expenses" element={<PermissionGuard requires="pme"><PMEExpensesPage /></PermissionGuard>} />
          <Route path="agri" element={<PermissionGuard requires="agri"><AgricultureModule /></PermissionGuard>} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </UserLayout>
    </>
  );
}

function AppContent() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { isAdmin, loading: adminLoading } = useAdminCheck();
  const { needsSubscription, trialEndsAt, loading: trialLoading, refresh: refreshTrialStatus } = useTrialStatus();
  const { impersonatedUserId } = useAuth();

  function handleNavigate(path: string) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  }

  if (loading || adminLoading || trialLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
          <p className="text-xs text-gray-400 mt-2">
            Auth: {loading ? 'en cours' : 'terminé'} | Admin: {adminLoading ? 'en cours' : 'terminé'} | Trial: {trialLoading ? 'en cours' : 'terminé'}
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage onGetStarted={() => navigate('/login')} onNavigate={handleNavigate} />} />
        <Route path="/fonctionnalites" element={<FonctionnalitesPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/fonctionnalites/prevision-tresorerie" element={<PrevisionTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/fonctionnalites/stress-test-tresorerie" element={<StressTestTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/fonctionnalites/suivi-subventions" element={<SuiviSubventionsPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/fonctionnalites/alertes-tresorerie" element={<AlertesTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/fonctionnalites/reporting-financier" element={<ReportingFinancierPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/fonctionnalites/tableau-bord-temps-reel" element={<TableauBordTempsReelPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/clients" element={<ClientsPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tarifs" element={<TarifsPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/gestion-tresorerie-agriculteur" element={<AgriculturePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/gestion-tresorerie-association" element={<GestionTresorerieAssociationPage />} />
        <Route path="/gestion-tresorerie-pme" element={<GestionTresoreriePMEPage />} />
        <Route path="/simulateur-tresorerie-association" element={<SimulateurTresorerieAssociationPage />} />
        <Route path="/beta-founders" element={<BetaFoundersPage />} />
        {/* Pages piliers SEO */}
        <Route path="/gestion-tresorerie" element={<GestionTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/plan-tresorerie" element={<PlanTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/prevision-tresorerie" element={<PrevisionTresorerieSeoPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/logiciel-tresorerie" element={<LogicielTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/logiciel-tresorerie-association" element={<LogicielTresorerieAssociationPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/logiciel-tresorerie-entreprise" element={<LogicielTresorerieEntreprisePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/gestion-tresorerie-tpe" element={<GestionTresorerieTPEPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        {/* Pages intention / conversion */}
        <Route path="/outil-prevision-tresorerie" element={<OutilPrevisionTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/logiciel-prevision-tresorerie" element={<LogicielPrevisionTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        {/* Pages longue traîne */}
        <Route path="/excel-tresorerie-association" element={<ExcelTresorerieAssociationPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/modele-plan-tresorerie" element={<ModelePlanTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/plan-tresorerie-pme" element={<PlanTresoreriePMEPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/subvention-en-retard-tresorerie" element={<SubventionRetardTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/suivi-tresorerie-entreprise" element={<SuiviTresorerieEntrepriseExcelPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tableau-tresorerie-gratuit" element={<TableauTresorerieGratuitPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/bfr-tresorerie" element={<BFRTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/excel-vs-logiciel-tresorerie" element={<ExcelVsLogicielTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/manque-tresorerie" element={<ManqueTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/cash-flow-entreprise" element={<CashFlowEntreprisePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/prevision-tresorerie-simple" element={<TresorerieSimplePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/difference-tresorerie-resultat" element={<TresorerieVsResultatPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tresorerie-association-loi-1901" element={<TresorerieAssociationLoi1901Page onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/alerte-tresorerie" element={<AlerteTresoreriePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tresorerie-saisonniere-restaurant" element={<TresorerieSaisonniereRestaurantPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tresorerie-startup" element={<TresorerieStartupPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/probleme-cash-flow" element={<ProblemeCashFlowPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/reporting-financier-association" element={<ReportingFinancierAssociationPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/stress-test-tresorerie" element={<StressTestTresorerieSeoPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tresorerie-sci-immobilier" element={<TresorerieImmobilierPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tresorerie-freelance-independant" element={<TresorerieFreelancePage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/tresorerie-ess-economie-sociale" element={<TresorerieEssSocialPage onNavigate={handleNavigate} onSignIn={() => navigate('/login')} onSignUp={() => navigate('/login')} />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/login" element={<AuthPage onBackToLanding={() => navigate('/')} />} />
        <Route path="/reset-password" element={<ResetPasswordPage onResetComplete={() => navigate('/login')} />} />
        <Route path="/r/:code" element={<ReferralRedirectPage />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
        <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        <Route path="/conditions-generales-utilisation" element={<ConditionsGeneralesUtilisationPage />} />
        <Route path="/app/*" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  if (isAdmin && !impersonatedUserId) {
    return (
      <Routes>
        <Route path="/admin/*" element={<AdminDashboardNew />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
        <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        <Route path="/conditions-generales-utilisation" element={<ConditionsGeneralesUtilisationPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    );
  }

  if (needsSubscription) {
    return <SubscriptionRequired trialEndsAt={trialEndsAt} onRefresh={refreshTrialStatus} />;
  }

  return (
    <Routes>
      <Route path="/app/*" element={<AuthenticatedApp />} />
      <Route path="/r/:code" element={<ReferralRedirectPage />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
      <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
      <Route path="/conditions-generales-utilisation" element={<ConditionsGeneralesUtilisationPage />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <CookieConsentManager>
      <AppContent />
    </CookieConsentManager>
  );
}

export default App;
